export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/online_tutoring.1ff2a3f.svg";